// A sessão de verdade agora é um cookie httpOnly (emitido pelo colabi-api no
// login), que o JS nunca lê nem escreve — o navegador manda ele sozinho em
// toda requisição (withCredentials: true nas instâncias axios). Isso é o que
// realmente protege contra roubo de sessão via XSS.
//
// LOGGED_IN_FLAG abaixo NÃO é segredo nenhum — é só uma marca local pra UX
// (mostrar tela de login vs. app, nos guards de rota). Não autentica nada
// sozinha; sem o cookie, toda chamada à API continua sendo rejeitada.
const LOGGED_IN_FLAG = '@LoggedIn';

export const isAuthenticated = _ => {
    return localStorage.getItem(LOGGED_IN_FLAG) === '1';
};

// Mantido só por compatibilidade com código legado que ainda não migrou —
// não retorna mais o token real. Ver comentário no topo do arquivo.
export const getToken = _ => {
    return null;
};

export const login = _token => {
    localStorage.setItem(LOGGED_IN_FLAG, '1');
};

export const logout = _ => {
    localStorage.removeItem(LOGGED_IN_FLAG);
}